import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ListingFilterSeo from "./component";
import {
    updateSelectedSuggestions,
    updateFilterOptionData,
    updateSelectedOnScreenFilter,
    updateAllFiltersVisibility,
    fetchListingCount,
    updateAppliedFilters,
    updateAppliedSuggestions,
    updateSortModalVisibility,
    replaceSelectedFilter
} from "../filters/actions";
import { reloadCarList, resetCarList } from "../car-listing/actions";

const mapStateToProps = ({
    filters: {
        allFilters,
        selectedSuggestions,
        selectedOnScreenFilter,
        onScreenFilters,
        showAllFilters,
        listingCount,
        selectedFilters,
        appliedFilters,
        isListingCountLoading,
        urlOptions,
        config
    },

    location: {
        selectedCity
    }
}) => ({
    allFilters,
    selectedSuggestions,
    selectedOnScreenFilter,
    onScreenFilters,
    showAllFilters,
    listingCount,
    selectedFilters,
    appliedFilters,
    isListingCountLoading,
    urlOptions,
    selectedCity,
    config
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateSelectedSuggestionsConnect: updateSelectedSuggestions,
    updateFilterOptionDataConnect: updateFilterOptionData,
    updateSelectedOnScreenFilterConnect: updateSelectedOnScreenFilter,
    updateAllFiltersVisibilityConnect: updateAllFiltersVisibility,
    fetchListingCountConnect: fetchListingCount,
    updateAppliedFiltersConnect: updateAppliedFilters,
    updateAppliedSuggestionsConnect: updateAppliedSuggestions,
    updateSortModalVisibilityConnect: updateSortModalVisibility,
    reloadCarListConnect: reloadCarList,
    resetCarListConnect: resetCarList,
    replaceSelectedFilterConnect: replaceSelectedFilter
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ListingFilterSeo);
